import { CanMatchFn, RedirectCommand, Router, Routes } from "@angular/router";

import { inject } from "@angular/core";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DashboardAllChartComponent } from "./dashboard-all-chart/dashboard-all-chart.component";
import { TruckStatusComponent } from "./dashboard/chart-components/truck-status/truck-status.component";
import { FleetManagementComponent } from "./fleet-management/fleet-management.component";
import { CustomerManagementComponent } from "./customer-management/customer-management.component";
import { ConsigneeRegistrationComponent } from "./consignee-registration/consignee-registration.component";
import { ReportComponent } from "./report/report.component";
import { AccountingComponent } from "./accounting/accounting.component";
import { LoginComponent } from "./login/login.component";
import { AuthGuard } from "./auth.guard";
import { HomeComponent } from "./home/home.component";
import { DashboardBackupComponent } from "./dashboard-backup/dashboard-backup.component";
import { TruckProfileComponent } from "./fleet-management/truck-profile/truck-profile.component";
import { DriverProfileComponent } from "./fleet-management/driver-profile/driver-profile.component";
import { TransportMangagementComponent } from "./fleet-management/transport-management/transport-mangagement.component";
import { CustomerRegistrationComponent } from "./customer-management/customer-registration/customer-registration.component";
import { ConsigneeRegistrationFormComponent } from "./consignee-registration/consignee-registration-form/consignee-registration-form.component";
import { OrderBookingComponent } from "./shipping-order/booking-list/order-booking/order-booking.component";
import { BookingListComponent } from "./shipping-order/booking-list/booking-list.component";
import { OrderTrackingComponent } from "./shipping-order/order-tracking/order-tracking.component";
import { OrderTrackingDetailComponent } from "./shipping-order/order-tracking/order-tracking-detail/order-tracking-detail.component";
import { TrackingMapsDetailComponent } from "./shipping-order/order-tracking/order-tracking-detail/tracking-maps-detail/tracking-maps-detail.component";
import { DriverRegistrationComponent } from "./fleet-management/driver-profile/driver-registration/driver-registration.component";
import { TruckRegistrationComponent } from "./fleet-management/truck-profile/truck-registration/truck-registration.component";
import { ReportRegistrationComponent } from "./report/report-registration/report-registration.component";
import { UserManagementComponent } from "./user-management/user-management.component";
import { UserRegistrationComponent } from "./user-management/user-registration/user-registration.component";
import { UserSettingsComponent } from "./settings/user-settings/user-settings.component";
import { TruckSettingsComponent } from "./settings/truck-settings/truck-settings.component";
import { CustomerSettingsComponent } from "./settings/customer-settings/customer-settings.component";
import { ReportPredefindDataComponent } from "./settings/report-predefind-data/report-predefine-list/report-predefind-data.component";
import { ReportPredefindAddNewComponent } from "./settings/report-predefind-data/report-predefind-add-new/report-predefind-add-new.component";

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        title: 'Fleet Management'
    },
    {
        path: 'home',
        component: HomeComponent,
        title: 'Fleet Management',
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
                title: 'Dashboard'
            },
            {
                path: 'dashboard-backup',
                component: DashboardBackupComponent,
                title: 'Dashboard'
            },
            {
                path: 'fleet-management',
                component: FleetManagementComponent,
                title: 'Fleet Management'
            },
            {
                path: 'truck-profile',
                component: TruckProfileComponent,
                title: 'Truck Profile'
            },
            {
                path: 'truck-profile/registration',
                component: TruckRegistrationComponent,
                title: 'Truck Registration'
            },
            { path: 'truck-profile/registration/:id', component: TruckRegistrationComponent },
            {
                path: 'driver-profile',
                component: DriverProfileComponent,
                title: 'Driver Profile'
            },
            {
                path: 'driver-profile/driver-registration',
                component: DriverRegistrationComponent,
                title: 'Driver Registration'
            },
            { path: 'driver-profile/driver-registration/:id', component: DriverRegistrationComponent },
            {
                path: 'transport-management',
                component: TransportMangagementComponent,
                title: 'Transport Management'
            },
            {
                path: 'customer-management',
                component: CustomerManagementComponent,
                title: 'Customer Management'
            },
            {
                path: 'customer-management/registration',
                component: CustomerRegistrationComponent,
                title: 'Customer Registration'
            },
            { path: 'customer-management/registration/:id', component: CustomerRegistrationComponent },
            {
                path: 'consignee-registration',
                component: ConsigneeRegistrationComponent,
                title: 'Consignee Registration'
            },
            {
                path: 'consignee-registration/register-form',
                component: ConsigneeRegistrationFormComponent,
                title: 'Consignee Registration Form'
            },
            { path: 'consignee-registration/consignee-form/:id', component: ConsigneeRegistrationFormComponent },
            {
                path: 'booking-list',
                component: BookingListComponent,
                title: 'Booking List'
            },
            {
                path: 'shipping-order/booking-list/order-booking',
                component: OrderBookingComponent,
                title: 'Order Booking'
            },
            {
                path: 'shipping-order/booking-list/order-booking/:id',
                component: OrderBookingComponent,
                title: 'Order Booking'
            },
            {
                path: 'shipping-order/order-tracking',
                component: OrderTrackingComponent,
                title: 'Order Tracking'
            },
            {
                path: 'shipping-order/order-tracking/detail',
                component: OrderTrackingDetailComponent,
                title: 'Order Tracking Detail'
            },
            {
                path: 'shipping-order/order-tracking/detail/maps',
                component: TrackingMapsDetailComponent,
                title: 'Order Tracking Maps'
            },
            {
                path: 'report',
                component: ReportComponent,
                title: 'Report'
            },
            {
                path: 'report/register',
                component: ReportRegistrationComponent,
                title: 'Report Register'
            },
            {
                path: 'accounting',
                component: AccountingComponent,
                title: 'Accounting'
            },
            {
                path: 'dashboard-all-chart',
                component: DashboardAllChartComponent,
                title: 'Dashboard All Chart'
            },
            {
                path: 'truck-staus',
                component: TruckStatusComponent,
                title: 'Truck Status'
            },
            {
                path: 'user-management',
                component: UserManagementComponent,
                title: 'User Management'
            },
            {
                path: 'user-management/register',
                component: UserRegistrationComponent,
                title: 'User Register'
            },
            { path: 'user-management/register/:id', component: UserRegistrationComponent },
            {
                path: 'settings/user-settings',
                component: UserSettingsComponent,
                title: 'User Settings'
            },
            {
                path: 'settings/truck-settings',
                component: TruckSettingsComponent,
                title: 'Truck Settings'
            },
            {
                path: 'settings/customer-settings',
                component: CustomerSettingsComponent,
                title: 'Customer Settings'
            },
            {
                path: 'settings/report-predefind-data',
                component: ReportPredefindDataComponent,
                title: 'Predefind Report'
            },
            {
                path: 'settings/report-predefind-data/report-predefind-add-new',
                component: ReportPredefindAddNewComponent,
                title: 'Add New Report Data'
            },
            {
                path: 'settings/report-predefind-data/report-predefind-add-new/:id',
                component: ReportPredefindAddNewComponent,
                title: 'Add New Report Data'
            },
          ],
    },
    
    
    // { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
    { path: 'login', component: LoginComponent },
    { 
        path: '', 
        redirectTo: 'login', 
        pathMatch: 'full' 
    }, // Redirect root path to login
    { 
        path: '**', 
        redirectTo: 'login' 
    },
]